<template>
  <div
    class="tooltip-info cursor-pointer"
    :class="[...classes.tooltip]"
    @mouseover="show = true"
    @mouseleave="show = false"
  >
    <VSvgIcon name="information" class="w-5 ml-1 text-ricoma-gray-500" :class="[...classes.icon]" />
    <TooltipPopup v-if="show" :class="[...classes.popup]">
      <template>
        <slot>{{ content }}</slot>
      </template>
    </TooltipPopup>
  </div>
</template>

<script>
import VSvgIcon from '@/components/base/VSvgIcon';
import TooltipPopup from './TooltipPopup.vue';

export default {
  name: 'TooltipInfo',
  components: { VSvgIcon, TooltipPopup },
  props: {
    content: {
      type: String,
      required: false,
      default: '',
    },
    classes: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  data() {
    return {
      show: false,
    };
  },
};
</script>
